import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumbs from "@/components/base/Breadcrumbs";
import CategoryBrowser from "@/pages/category/components/CategoryBrowser";
import { titles } from "@/mocks/titles";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function MovieCategoryPage() {
  usePageMeta(
    "奇优影院-最新电影分类与推荐",
    "奇优影院电影分类页，按类型、地区、年份筛选最新上映影片，查看影片简介、导演主演与相关推荐，快速找到想看的电影。",
    "电影分类,最新电影,热门影片,奇优影院",
  );

  const movies = titles.filter((item) => item.type === "movie");

  return (
    <SiteLayout>
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-5 md:pt-7">
        <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "电影" }]} />

        <div className="rounded-lg bg-background-100 border border-background-200 px-4 py-5 md:px-6 md:py-7 mb-5">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
            <div>
              <h1 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
                电影 · 分类与推荐
              </h1>
              <p className="text-sm text-foreground-600 mt-2 max-w-2xl leading-relaxed">
                汇集院线新片与类型佳作，按类型、地区、年份组合筛选，查看每部电影的剧情概要、主创信息与相关推荐。
              </p>
            </div>
            <div className="flex items-center gap-4 shrink-0">
              <div className="text-center">
                <p className="text-xl font-extrabold font-heading text-primary-700">{movies.length}</p>
                <p className="text-[11px] text-foreground-500">部电影</p>
              </div>
              <div className="w-px h-8 bg-background-300" />
              <div className="text-center">
                <p className="text-xl font-extrabold font-heading text-accent-600">
                  {new Set(movies.flatMap((item) => item.genres)).size}
                </p>
                <p className="text-[11px] text-foreground-500">种类型</p>
              </div>
            </div>
          </div>
        </div>

        <CategoryBrowser items={movies} categoryLabel="电影" />
      </div>
    </SiteLayout>
  );
}